import { FC, useEffect, useRef } from 'react';
import { useParams, useNavigate } from 'react-router';

import { BodyLoading } from '@cvt/components/layout/BodyLoading';

import { useEnrollments } from '../hooks/useEnrollments';
import { programClient } from '../client/programClient';


export const ProgramEnroll: FC = () => {
  const { programId } = useParams<{ programId: string }>();
  const navigate = useNavigate();
  const { enrollments } = useEnrollments();
  const enrollingRef = useRef(false);

  const existingEnrollment = enrollments.find(
    e => e.program.id === Number(programId) && !e.completedAt,
  );

  useEffect(() => {
    if (!programId) return;

    if (existingEnrollment) {
      navigate(`/programs/journey/${existingEnrollment.id}/step`, { replace: true });
      return;
    }

    if (enrollingRef.current) return;
    enrollingRef.current = true;

    programClient.createEnrollment({ program: Number(programId) })
      .then((response) => {
        navigate(`/programs/journey/${response.data.id}/step`, { replace: true });
      })
      .catch((error) => {
        console.error(error);
        enrollingRef.current = false;
      });
  }, [programId, existingEnrollment, navigate]);

  return <BodyLoading height="60vh"/>;
};
